<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-evgPrePurchaseOrder',
  components: { PageTable },
}
</script>
